import styled from 'styled-components'

export const HintTextWrapper = styled.div`
  margin-left: -0.5rem;
`
